<script setup>
import { ref, watch, nextTick, onMounted, computed } from "vue"
import { useWindowSize } from "@vueuse/core"

import ImgBanner from "@/assets/talento_agv/img/dashboard_postulante/banner1.png"
import ImgGPTW from "@/assets/talento_agv/img/dashboard_postulante/gptw2.png"
import HeaderDashboard from "@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/header.vue"
import Select2 from 'vue3-select2-component'
import "select2/dist/css/select2.min.css"
import { useRoute } from "vue-router"

const route = useRoute()

/* ⭐ Detecta mobile en tiempo real */
const { width } = useWindowSize()
const isMobile = computed(() => width.value < 768)

const loadingLogin = ref(false)
const userData = ref([])
const languages = ref(['Spanish', 'English'])

const selPositions = ref([])
const selPlaces = ref([])

const keywordSearch = ref(route.query.keyword || null)
const selectedPosition = ref(route.query.position ? [route.query.position] : [])
const selectedPlace = ref(route.query.place ? [route.query.place] : [])

const positions = ref(['Analista', 'Auxiliar', 'Asistente'])
const places = ref(['Lima', 'Cajamarca', 'Chiclayo', 'Olmos'])

const select2Settings = (placeholder = "") => ({
    placeholder,
    multiple: true,
    closeOnSelect: false,
    width: "100%",
    allowClear: true,
    dropdownParent: document.body,
})

const paintOne = (refComp, arr, placeholder) => {
    nextTick(() => {
        const root = refComp?.$el || refComp
        const rendered = root?.querySelector(".select2-selection__rendered")
        if (!rendered) return

        let sum = rendered.querySelector(".select2-summary")
        if (!sum) {
            sum = document.createElement("span")
            sum.className = "select2-summary"
            rendered.appendChild(sum)
        }

        if (!arr || arr.length === 0) {
            sum.textContent = placeholder
            sum.classList.add("is-placeholder")
            sum.title = ""
        } else {
            sum.textContent = arr.join(", ")
            sum.classList.remove("is-placeholder")
            sum.title = arr.join(", ")
        }
    })
}

onMounted(() => {
    paintOne(selPositions.value, selectedPosition.value, "Puesto")
    paintOne(selPlaces.value, selectedPlace.value, "Lugar")
})

watch(selectedPosition, (newVal) => {
    paintOne(selPositions.value, newVal, "Puesto")
}, { deep: true })

watch(selectedPlace, (newVal) => {
    paintOne(selPlaces.value, newVal, "Lugar")
}, { deep: true })
</script>

<template>
    <HeaderDashboard/>
    <!-- Works Banner -->
    <section>
        <div class="banner-home-header">
            <div class="container">
                <div
                    loading="lazy"
                    class="img-banner-home-header"
                    :style="{ backgroundImage: `url(${ImgBanner})` }"
                ></div>
                <img
                v-if="!isMobile"
                :src="ImgGPTW"
                width="70px"
                alt="Certificado"
                class="position-absolute"
                style="margin-left: 30px; top:170px; z-index:5;"
                />
            </div>

            <div class="sobrefondo"></div>

            <div class="container banner-content-works">
                <h1 class="banner-title">Ofertas Laborales</h1>

                <form class="search-bar">
                    <input
                    v-model="keywordSearch"
                    type="text"
                    placeholder="Busca por palabra clave"
                    style="margin-left: 12px;"
                    />

                    <Select2
                    ref="selPositions"
                    placeholder="Posicion"
                    v-model="selectedPosition"
                    :options="positions"
                    :settings="select2Settings('Puesto')"
                    />

                    <Select2
                    ref="selPlaces"
                    placeholder="Lugar"
                    v-model="selectedPlace"
                    :options="places"
                    :settings="select2Settings('Lugar')"
                    />

                    <div class="search-icon-wrapper">
                        <router-link 
                        :to="{ 
                            path: '/dashboard_ofertas_laborales', 
                            query: { 
                            keyword: keywordSearch, 
                            position: selectedPosition, 
                            place: selectedPlace 
                            } }" 
                        tabindex="-1"
                        class="px-2"
                        >
                        <i class="bx bx-search text-white fs-5 align-middle"></i>
                        </router-link>
                    </div>
                </form>

                <div v-if="isMobile" class="gptw-mobile-wrapper">
                    <img :src="ImgGPTW" alt="Certificado" class="gptw-mobile-img" />
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>

.shadow{
    background-color: rgba(0,0,0,0.55); 
    z-index: 5;
}

/* Banner */
.banner-home-header {
    height: 32vh;
    min-height: 260px;
}

.banner-content-works {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 60px;
}

.banner-title {
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    line-height: 5rem;
    text-align: left;
}

.img-banner-home-header {
    background-position: center center;
    background-size: cover;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}

.search-bar {
    display: flex;
    gap: 0.5rem;
    width: 90%;
    max-width: 768px;
    padding: 0.5rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(6px);
    align-items: center;
}

.search-icon-wrapper {
    margin-left: auto;
    display: flex;
    align-items: center;
}

.search-bar input {
    flex: 1;
    min-width: 0;
    border: 0;
    background: transparent;
    padding: 6px 8px;
    color: #222;
    outline: none;
    border-right: 1px solid #fff;
}

.search-bar > span {
    margin-left: auto;
    display: flex;
    align-items: center;
}

.gptw-mobile-wrapper {
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
}

.gptw-mobile-img {
    width: 50px;
}

/* Span del select */
::v-deep(.search-bar .select2-container) {
    flex: 1 1 220px;
    min-width: 160px;
    width: auto !important;
    border-right: 1px solid #fff;
}

::v-deep(.search-bar .select2-container--default .select2-selection--multiple) {
    background: transparent;
    border: 0;
    min-height: 44px;
    padding: 6px 8px;
    display: flex;
    justify-content: center;
    max-width: 160px;
}

/* Rendered Options */
::v-deep(.search-bar .select2-selection__rendered) {
    display: flex !important;
    text-align: start;
    align-items: center;
    margin-left: 0px !important;
}

::v-deep(.select2-selection__rendered .select2-selection__clear) {
    display: none;
}

::v-deep(.search-bar .select2-selection__choice) {
    display: none !important;
}

/* Input Select */
::v-deep(.search-bar .select2-search--inline input) {
    display: none !important;
}

::v-deep(.search-bar .select2-summary) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: inline-block;
}

::v-deep(.search-bar .select2-summary.is-placeholder) {
    color: rgba(0, 0, 0, 0.45);
}

.search-bar > span {
    flex: 0 0 auto;
}

.certificado-badge {
    position: absolute;
    z-index: 3;
    left: 7%;
    top: 25%;
    width: 70px;
    border-radius: 12px;
}

.btn-link-reset {
    background: none;
    border: 0;
    padding: 0;
    color: var(--bg-primary-as-light);
    font-weight: 500;
    cursor: pointer;
}

.btn-link-reset:hover {
    text-decoration: underline;
}

.topbar-link {
    background: transparent;
    border: 0;
    padding: 0;
    color: var(--bg-primary-as);
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    cursor: pointer;
}

.topbar-link i {
    font-size: 18px;
    color: var(--bg-primary-as);
}

.topbar-link:hover {
    color: var(--bg-primary-as-light);
}

.topbar-link:hover i {
    color: var(--bg-primary-as-light);
}

.topbar-link:disabled,
.topbar-link[disabled] {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
}

.content-job-card {
    margin-top: 100px;
    display: flex;
    justify-content: center;
}

/* Responsive */
@media (max-width: 768px) {
    .banner-title {
        font-size: 32px;
        line-height: 3.5rem;
    }

    .search-bar {
        flex-wrap: wrap;
        border-radius: 24px;
    }

    .search-bar input {
        flex-basis: 100%;
        border: 0px;
    }

    ::v-deep(.search-bar .select2-container) {
        flex: 1 1 calc(50% - 0.5rem);
        min-width: 250px;
        margin-left: 0 !important;
    }
}

@media (max-width: 640px) {
    ::v-deep(.search-bar .select2-container) {
        flex: 1 1 calc(50% - 0.5rem);
        min-width: 180px;
        margin-left: 0 !important;
    }
}

@media (max-width: 576px) {
    .banner-title {
        font-size: 26px;
        line-height: 2.5rem;
    }

    ::v-deep(.search-bar .select2-container) {
        min-width: 160px;
        margin-left: 0 !important;
    }
}

@media (max-width: 445px) {
    ::v-deep(.search-bar .select2-container) {
        min-width: 100px;
    }

    ::v-deep(
        .search-bar .select2-container--default .select2-selection--multiple
        ) {
        max-width: 100px;
    }
}

@media (max-width: 310px) {
    ::v-deep(.search-bar .select2-container) {
        min-width: 70px;
    }

    ::v-deep(
        .search-bar .select2-container--default .select2-selection--multiple
        ) {
        max-width: 70px;
    }
}

</style>